import { KWELLO_ICON } from 'common/components/icon/KwelloSvgIcon';
import KwelloIconButton from 'common/components/KwelloButton/KwelloIconButton';
import { useNavigateWithProjectId } from 'common/hooks/route';
import useDevMode from 'common/hooks/useDevMode';
import { Feature } from 'common/models/page-config.models';
import { DEVELOPMENT_ROUTES } from 'routes/routes.const';

function DevelopmentButton() {
  const devMode = useDevMode();
  const featureSlot = sessionStorage.getItem('featureSlot');
  const featureFlagOverrides = JSON.parse(
    sessionStorage.getItem('featureFlags') ?? '[]'
  ) as Feature[];
  const navigate = useNavigateWithProjectId();

  const navigateToDevelopmentPage = () => {
    navigate(DEVELOPMENT_ROUTES.root);
  };

  if (!devMode) {
    return null;
  }

  return (
    <>
      {featureFlagOverrides.length > 0 && (
        <div
          className="feature-slot flex-row align-center"
          style={{ color: 'red', fontWeight: 'bold' }}
        >
          Feature Flags Override Enabled
        </div>
      )}
      {featureSlot && featureSlot !== 'Dev' && (
        <div
          className="feature-slot flex-row align-center"
          style={{ color: 'red', fontWeight: 'bold' }}
        >
          API: Feature Slot {featureSlot}
        </div>
      )}
      <div>
        <KwelloIconButton
          icon={KWELLO_ICON.SETTINGS_ICON}
          onClick={navigateToDevelopmentPage}
          tooltip="Development Page"
        />
      </div>
    </>
  );
}

export default DevelopmentButton;
